export const data = {
  title_am: 'Համալիր հետազոտություններ',
  title_en: 'Comprehensive Health Check-Ups',
  title_ru: 'Комплексные исследования',
  info_am: 'Մեր ծառայությունները',
  info_en: 'Our Services',
  info_ru: 'Наши услуги',
  description_am: 'Առողջության համալիր գնահատում՝ անհրաժեշտ հետազոտությունների համակցությամբ: Ընտրեք Ձեզ համապատասխանող համալիր հետազոտությունը',
  description_en: 'Comprehensive health assessment through a combination of essential tests. Choose the comprehensive check-up that is right for you.',
  description_ru: 'Комплексная оценка здоровья с помощью необходимых исследований. Выберите комплексное исследование, которое подходит именно Вам.',
};
